var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11V12.6667C10 13.2879 10 13.5986 9.89851 13.8436C9.76318 14.1703 9.50362 14.4299 9.17691 14.5652C8.93188 14.6667 8.62126 14.6667 8 14.6667C7.37874 14.6667 7.06812 14.6667 6.82309 14.5652C6.49638 14.4299 6.23682 14.1703 6.10149 13.8436C6 13.5986 6 13.2879 6 12.6667V11M10 11C11.7659 10.2285 13 8.38366 13 6.33334C13 3.57192 10.7614 1.33334 8 1.33334C5.23858 1.33334 3 3.57192 3 6.33334C3 8.38366 4.2341 10.2285 6 11M10 11H6",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesInsight);
export default __webpack_public_path__ + "static/media/sales-insight.db7513d5ac50872b2895180c399c7225.svg";
export { ForwardRef as ReactComponent };